module.exports = __webpack_public_path__ + "static/media/house8.d5a2dd54.webp";